import { render, staticRenderFns } from "./MelonTVVideo.vue?vue&type=template&id=11bd7d92&"
import script from "./MelonTVVideo.vue?vue&type=script&lang=js&"
export * from "./MelonTVVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports